"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecisionModelQuestionsSchema = exports.DecisionModelQuestionSchema = exports.DecisionModelNoulQuestionSchema = exports.DecisionModelScoreQuestionSchema = exports.DecisionModelChoiceQuestionSchema = exports.DecisionModelChoiceOptionSchema = exports.DecisionModelStateKeySchema = exports.DecisionModelEntrySchema = exports.DECISION_MODEL_LIMITS = exports.DecisionModelQuestionType = void 0;
exports.parseDecisionModelQuestions = parseDecisionModelQuestions;
const zod_1 = require("zod");
const zod_2 = require("../../utils/zod");
exports.DecisionModelQuestionType = {
    CHOICE: "choice",
    SCORE: "score",
    NOUL: "noul",
};
exports.DECISION_MODEL_LIMITS = {
    maxQuestions: 50,
    minChoiceOptions: 2,
    maxChoiceOptions: 255,
    minScoreLevels: 2,
    maxScoreLevels: 10,
    maxInstructionLength: 20_000,
    maxScoreNameLength: 100,
};
exports.DecisionModelEntrySchema = zod_1.z.union([
    zod_1.z.string().trim().min(1).max(exports.DECISION_MODEL_LIMITS.maxInstructionLength),
    zod_2.jsonSchema,
]);
const STATE_KEY_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*$/;
exports.DecisionModelStateKeySchema = zod_1.z
    .string()
    .regex(STATE_KEY_PATTERN, "State keys must start with a letter or underscore and contain only letters, digits, and underscores");
const DecisionModelQuestionBaseSchema = zod_1.z.object({
    id: zod_1.z.string().trim().min(1).max(64),
    scoreName: zod_1.z
        .string()
        .trim()
        .min(1)
        .max(exports.DECISION_MODEL_LIMITS.maxScoreNameLength),
    instructions: exports.DecisionModelEntrySchema,
});
exports.DecisionModelChoiceOptionSchema = zod_1.z.object({
    value: zod_1.z.string().trim().min(1).max(100),
    description: exports.DecisionModelEntrySchema.nullish(),
});
exports.DecisionModelChoiceQuestionSchema = DecisionModelQuestionBaseSchema.extend({
    type: zod_1.z.literal(exports.DecisionModelQuestionType.CHOICE),
    options: zod_1.z
        .array(exports.DecisionModelChoiceOptionSchema)
        .min(exports.DECISION_MODEL_LIMITS.minChoiceOptions)
        .max(exports.DECISION_MODEL_LIMITS.maxChoiceOptions)
        .refine((options) => new Set(options.map((option) => option.value)).size ===
        options.length, { message: "Choice options must be unique" }),
});
exports.DecisionModelScoreQuestionSchema = DecisionModelQuestionBaseSchema.extend({
    type: zod_1.z.literal(exports.DecisionModelQuestionType.SCORE),
    levels: zod_1.z
        .array(zod_1.z.object({ description: exports.DecisionModelEntrySchema }))
        .min(exports.DECISION_MODEL_LIMITS.minScoreLevels)
        .max(exports.DECISION_MODEL_LIMITS.maxScoreLevels),
});
exports.DecisionModelNoulQuestionSchema = DecisionModelQuestionBaseSchema.extend({
    type: zod_1.z.literal(exports.DecisionModelQuestionType.NOUL),
    criteria: zod_1.z
        .object({
        true: exports.DecisionModelEntrySchema.nullish(),
        false: exports.DecisionModelEntrySchema.nullish(),
    })
        .nullish(),
});
exports.DecisionModelQuestionSchema = zod_1.z.discriminatedUnion("type", [
    exports.DecisionModelChoiceQuestionSchema,
    exports.DecisionModelScoreQuestionSchema,
    exports.DecisionModelNoulQuestionSchema,
]);
exports.DecisionModelQuestionsSchema = zod_1.z
    .array(exports.DecisionModelQuestionSchema)
    .min(1)
    .max(exports.DECISION_MODEL_LIMITS.maxQuestions)
    .superRefine((questions, ctx) => {
    const ids = new Set();
    const scoreNames = new Set();
    questions.forEach((question, index) => {
        if (ids.has(question.id)) {
            ctx.addIssue({
                code: "custom",
                message: `Duplicate question id "${question.id}"`,
                path: [index, "id"],
            });
        }
        ids.add(question.id);
        if (scoreNames.has(question.scoreName)) {
            ctx.addIssue({
                code: "custom",
                message: `Score name "${question.scoreName}" is used by more than one question`,
                path: [index, "scoreName"],
            });
        }
        scoreNames.add(question.scoreName);
    });
});
function parseDecisionModelQuestions(value) {
    const parsed = exports.DecisionModelQuestionsSchema.safeParse(value);
    if (parsed.success)
        return { success: true, data: parsed.data };
    return {
        success: false,
        error: parsed.error.issues
            .map((issue) => `${issue.path.join(".")}: ${issue.message}`)
            .join("; "),
    };
}
